import React from "react";
import { Card } from "primereact/card";
import { INFO_ITEMS } from "./constants";

export function InfoSection() {
  return (
    <Card className="mt-6 border-none shadow-4 info-card">
      <div className="grid p-4">
        {INFO_ITEMS.map((item, index) => (
          <div key={index} className="col-12 md:col-4 text-center">
            <div className="info-icon" style={{ background: item.gradient }}>
              <i className={`${item.icon} text-xl text-white`}></i>
            </div>
            <h4 className="text-900 font-bold mb-2 text-lg">{item.title}</h4>
            <p className="text-600 text-sm line-height-3 px-2">
              {item.description}
            </p>
          </div>
        ))}
      </div>
    </Card>
  );
}
